import styled from "styled-components";
import { DeleteOutlined } from "@ant-design/icons";

export const DeleteIcon = styled(DeleteOutlined)`
  color: ${({ theme }) => theme.colors.blueDianne};
`;
